import React from 'react';
import { InformationContextValue } from './types';

const InformationDashboard409AContext = React.createContext<InformationContextValue>({
  handleGetCurrentInformationRequests: () => Object,
  currentDocuments: undefined,
});

export default InformationDashboard409AContext;
